import { observable } from 'mobx';

export type ArrangerResponseArgs = {
  id?: number;
  name?: string;
  last_name?: string;
  first_name?: string;
  email?: string;
  deleted_at?: string | null;
};

export type ArrangerArgs = {
  id?: number;
  name?: string;
  lastName?: string;
  firstName?: string;
  email?: string;
  deletedAt?: string | null;
};

export const convertArrangerResponseToArgs = (response: ArrangerResponseArgs): ArrangerArgs => {
  return {
    id: response.id,
    name: response.name,
    lastName: response.last_name,
    firstName: response.first_name,
    email: response.email,
    deletedAt: response.deleted_at
  };
};

export default class Arranger {
  @observable id?: number;
  @observable name: string;
  @observable lastName: string;
  @observable firstName: string;
  @observable email: string;
  @observable deletedAt: string | null;

  constructor(args: ArrangerArgs = {}) {
    this.id = args.id;
    this.name = args.name || '';
    this.lastName = args.lastName || '';
    this.firstName = args.firstName || '';
    this.email = args.email || '';
    this.deletedAt = args.deletedAt || null;
  }

  get submitParams() {
    return {
      last_name: this.lastName,
      first_name: this.firstName,
      email: this.email
    };
  }

  static empty() {
    return new Arranger({ lastName: '', firstName: '', email: '' });
  }
}
